// extracted by mini-css-extract-plugin
export default {"title":"YoutubeAnalytics_title__Gq9vR","itemContainer":"YoutubeAnalytics_itemContainer__cc51b","label":"YoutubeAnalytics_label__WOUsN","value":"YoutubeAnalytics_value__ju3B6"};